import type { AlertIssue } from '../store/types';
import {
  mapFieldRefToSelector,
  normalizePhaseNameForSelector
} from './fieldMapper';

function normalizeRefKey(s: string): string {
  return s.toLowerCase().replace(/[.\s_-]+/g, '_');
}

function phaseKeyMatches(
  currentPhaseName: string | undefined,
  phaseTokenFromAlert: string
): boolean {
  if (!currentPhaseName) return false;
  const currentKey = currentPhaseName.replace(/\s+/g, '_');
  const normalizedCurrent = normalizeRefKey(currentKey);
  const variants = normalizePhaseNameForSelector(phaseTokenFromAlert);
  return variants.some(v => normalizeRefKey(v) === normalizedCurrent);
}

export function matchesOverviewAlertIssue(
  issue: AlertIssue,
  field: 'headline'
): boolean {
  const mapping = mapFieldRefToSelector(issue.fieldRef, issue.ruleId);
  if (!mapping || mapping.section !== 'overview') return false;
  if (field !== 'headline') return false;
  return mapping.selector.includes('[data-testid="overview-field-headline"]');
}

export function matchesGeneralInfoDateAlertIssue(
  issue: AlertIssue,
  args: {
    fieldId: string;
    phaseName?: string;
  }
): boolean {
  const mapping = mapFieldRefToSelector(issue.fieldRef, issue.ruleId);
  if (!mapping || mapping.section !== 'general-info') return false;

  const selectorFieldMatch = mapping.selector.match(
    /general-info-date-field-([a-zA-Z0-9_-]+)/
  );
  const selectorFieldId = selectorFieldMatch?.[1];
  if (!selectorFieldId) return false;

  // targetStart and marketingMoment are equivalent in this UI model.
  const normalizeFieldId = (id: string) =>
    id === 'targetStart' ? 'marketingMoment' : id;
  const currentField = normalizeFieldId(args.fieldId);
  const alertField = normalizeFieldId(selectorFieldId);
  if (currentField !== alertField) return false;

  if (mapping.phaseName) {
    return phaseKeyMatches(args.phaseName, mapping.phaseName);
  }

  return true;
}
